// extracted by mini-css-extract-plugin
export default {"main-dropdown":"styles_main-dropdown__mVkHF","main-dropdown-container":"styles_main-dropdown-container__7UVA+","modal-dropdown":"styles_modal-dropdown__RkX5v"};